import { render, staticRenderFns } from "./ShareBun.vue?vue&type=template&id=451134ae"
import script from "./ShareBun.vue?vue&type=script&lang=js"
export * from "./ShareBun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports